module.exports = __webpack_public_path__ + "img/Gradiant.caa0718c.png";